module.exports = __webpack_public_path__ + "img/swipe (3).6be7a673.jpg";